module.exports = __webpack_public_path__ + "img/1.c63e0568.png";